export default __webpack_public_path__ + "static/media/santa-maria-8.34b7232e.jpg";